import * as React from 'react';
import ExportComponent from "../components/ExportComponent/ExportComponent";

import {connect} from "react-redux";
import ISource from "../interfaces/ISource";

export interface IExportProps {
    sources: ISource[]
}

class ExportContainer extends React.PureComponent<IExportProps> {
    public render() {
        return (
            <ExportComponent {...this.props}/>
        );
    }
}

const mapStateToProps = (store: any) => ({
    sources: store.literature.sources
});

export default connect(mapStateToProps)(ExportContainer);


// WEBPACK FOOTER //
// ./src/containers/ExportContainer.tsx